import styled from "@emotion/styled";

export const NormalizationModalHeader = styled.div(_ => ({
    textAlign: "left",
}));

export const NormalizationModalInfo = styled.div(_ => ({
    display: "flex",
    justifyContent: "space-between",
    textAlign: "left",
    fontSize: "16px",
    marginBottom: "12px",
}));

export const AttachmentNormalizationInfoWrapper = styled.div(() => ({
    width: "536px",
}));
